import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import styled from 'styled-components';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import {cloneDeep} from 'lodash';
import MissionControlHeader from './mission_control_header';
import DatePicker from '../../components/inputs/date_picker';
import UpdateCompanyInternalDataMutation from '../../mutations/mission_control/update_company_internal_data_mutation';
import MigrateInvoiceDataMutation from '../../mutations/mission_control/migrate_invoice_data_mutation';
import UpdateResourceNumbersForAllPersonsInCompany from '../../mutations/mission_control/update_resource_numbers_for_all_persons_in_company_mutation';
import Util from '../../forecast-app/shared/util/util';
import {MODAL_TYPE, showModal} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';
import {injectIntl} from 'react-intl';
import {hideLoader, showLoader} from '../../containers/global_loader';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';

const CompanyList = styled.div`
	max-height: 100vh;
	overflow: hidden;
`;

class companyStats extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sortColumn: 'ID',
			sortAsc: true,
			pickerOpenFor: null,
			planChangeFor: null,
			minChangeOpenFor: null,
			minVirtualChangeOpenFor: null,
			includeExpiredTrials: false,
			includeCurrentTrials: false,
			tierChangeFor: null,
		};
	}

	componentDidMount() {
		const companyToShowRemoveModal = this.getUrlParameter('company');
		if (companyToShowRemoveModal) {
			this.showRemoveSeatsModal(Number(companyToShowRemoveModal));
		}
	}

	getUrlParameter(name) {
		name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
		const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		const results = regex.exec(window.location.href);
		return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	sort(val) {
		if (this.state.sortColumn === val) {
			this.setState({sortAsc: !this.state.sortAsc});
		} else {
			this.setState({sortAsc: true, sortColumn: val});
		}
	}

	openPicker(companyId) {
		this.setState({pickerOpenFor: companyId});
	}

	changeTrialDate(companyId, id, value) {
		this.setState({pickerOpenFor: null});
		const date = Util.GetYearMonthDateFromMomentDate(value);
		Util.CommitMutation(UpdateCompanyInternalDataMutation, {
			companyId: companyId,
			trialEndYear: date.year,
			trialEndMonth: date.month,
			trialEndDay: date.day,
		});
	}

	openPlanSelect(companyId) {
		this.setState({planChangeFor: companyId});
	}

	openMinChange(companyId) {
		this.setState({minChangeOpenFor: companyId});
	}

	openMinVirtualChange(companyId) {
		this.setState({minVirtualChangeOpenFor: companyId});
	}

	changeMinSeats(companyId) {
		this.setState({minChangeOpenFor: null});
		Util.CommitMutation(UpdateCompanyInternalDataMutation, {
			companyId: companyId,
			minimumSeats: parseInt(this.input.value),
		});
	}

	changeMinVirtualSeats(companyId) {
		this.setState({minVirtualChangeOpenFor: null});
		Util.CommitMutation(UpdateCompanyInternalDataMutation, {
			companyId: companyId,
			minimumVirtualSeats: parseInt(this.inputVirtual.value),
		});
	}

	shouldChangeToFreeForever(companyId) {
		if (this.state.tierChangeFor === null) {
			this.setState({tierChangeFor: companyId});
		} else {
			this.setState({tierChangeFor: null});
		}
	}

	changeToFreeForever(companyId) {
		this.setState({tierChangeFor: null});
		Util.CommitMutation(UpdateCompanyInternalDataMutation, {
			companyId: companyId,
			tier: 'FREE_FOREVER',
		});
	}

	toggleBlock(companyId, id) {
		const blocked = this.props.viewer.missionControlData.companyStats.find(company => company.companyId === companyId).accessBlocked;
		Util.CommitMutation(UpdateCompanyInternalDataMutation, {
			companyId: companyId,
			accessBlocked: !blocked,
		});
	}

	changeShow() {
		this.setState({includeExpiredTrials: !this.state.includeExpiredTrials});
	}

	changeShowCurrent() {
		this.setState({includeCurrentTrials: !this.state.includeCurrentTrials});
	}

	handleSeatsUpdate(newSeats, newVirtualSeats, companyId) {
		const company = this.props.viewer.missionControlData.companyStats.find(company => company.companyId === companyId);
		showLoader();
		Util.CommitMutation(
			UpdateCompanyInternalDataMutation,
			{
				companyId: companyId,
				seats: company.userSeats - Number(newSeats),
				virtualSeats: company.virtualSeats - newVirtualSeats,
			},
			res => {
				hideLoader();
				const data = res.UpdateCompanyInternalData.MissionControlCompanyStats;
				showModal({
					type: MODAL_TYPE.GENERIC,
					headerText: 'Seats removed',
					content: `Seats successfully removed. ${data.companyName} now has ${data.userSeats} seats and ${data.virtualSeats} virtual seats.`,
					buttons: [
						{
							text: 'Ok',
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.GREEN,
						},
					],
				});
			}
		);
	}

	showRemoveSeatsModal(companyId) {
		const company = this.props.viewer.missionControlData.companyStats.find(company => company.companyId === companyId);

		const {formatMessage} = this.props.intl;

		showModal({
			type: MODAL_TYPE.SEAT_MANAGEMENT,
			isAdd: false,
			isChargebee: true,
			freeVirtualUsers: false,
			showCardSection: false,
			numSeats: company.userSeats,
			curSeats: company.numActivePersons,
			curVirtualSeats: company.numVirtualUsers,
			numVirtualSeats: company.virtualSeats,
			minNumSeats: Math.max(company.minimumSeats, company.numActivePersons),
			minNumVirtualSeats: Math.max(company.minimumVirtualSeats, company.numVirtualUsers),
			removeSeatsReason: '',
			hideQuestions: true,
			title: formatMessage({id: 'settings_subscription.seats-remove'}) + ' for ' + company.companyName,
			buttons: [
				{
					text: formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
					cy: 'cancel-modal-button',
				},
				{
					text: formatMessage({id: 'common.remove'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.GREEN,
					cy: 'remove-seats-modal-button',
					callback: (newSeats, newVirtualSeats) => this.handleSeatsUpdate(newSeats, newVirtualSeats, companyId),
					mayBeLocked: true,
				},
			],
		});
	}

	migrateInvoices(companyId) {
		const onSuccess = response => {
			createToast({duration: 5000, message: response.MigrateInvoiceData.MissionControlMigrateInvoiceData.entriesMigrated + ' entries migrated'});
		};
		Util.CommitMutation(
			MigrateInvoiceDataMutation,
			{
				companyId: companyId,
			},
			onSuccess
		);
	}

	updateResourceNumbers(companyId) {
		this.setState({updatingResourceNumbers: true});

		const onSuccess = response => {
			this.setState({updatingResourceNumbers: false});
			createToast({duration: 5000, message: `${response?.updateResourceNumbersForAllPersonsInCompany?.queuedPersonIds?.length} persons queued for update`});
		};
		Util.CommitMutation(
			UpdateResourceNumbersForAllPersonsInCompany,
			{
				companyId,
			},
			onSuccess
		);
	}

	getTiersMessage(tiers) {
		switch (tiers) {
			case 'TRIAL':
				return 'TRIAL';
			case 'LITE':
				return 'LITE';
			case 'PRO':
				return 'PRO';
			case 'ENTERPRISE':
				return 'PLUS';
			case 'FREE_FOREVER':
				return 'FREE FOREVER';
			default:
				break;
		}
	}

	render() {
		const {actualPersonId} = this.props.viewer;
		const isSuperAdmin = process.env.CIRCLE_BRANCH !== 'production' || actualPersonId === 'UGVyc29uOjE=' || actualPersonId === 'UGVyc29uOjQ=';

		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		if (!this.props.viewer.missionControlData.companyStats) {
			return null;
		}
		let data = cloneDeep(this.props.viewer.missionControlData.companyStats).filter(company => {
			if (company.tier === 'TRIAL') {
				const trialEndDate = moment(company.trialEndDate, 'DD/MM/YYYY hh:mm');
				const now = moment();

				if (this.state.includeCurrentTrials && trialEndDate.isAfter(now)) {
					return true;
				} else if (this.state.includeExpiredTrials && trialEndDate.isBefore(now)) {
					return true;
				}

				return false;
			}

			return true;
		});
		const direction = this.state.sortAsc ? 1 : -1;

		if (this.state.sortColumn === 'ID') {
			data.sort((a, b) => {
				return a.companyId > b.companyId ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'NAME') {
			data.sort((a, b) => {
				return (a.companyName || '').toUpperCase() > (b.companyName || '').toUpperCase() ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'TIER') {
			data.sort((a, b) => {
				return (a.tier || '').toUpperCase() > (b.tier || '').toUpperCase() ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'END_DATE') {
			data.sort((a, b) => {
				const a_date = moment(a.trialEndDate, 'DD-MM-YYYY HH:mm');
				const b_date = moment(b.trialEndDate, 'DD-MM-YYYY HH:mm');
				return a_date.isBefore(b_date) ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'PROJECTS') {
			data.sort((a, b) => {
				return a.numOfProjects > b.numOfProjects ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'CARDS') {
			data.sort((a, b) => {
				return a.numOfCards > b.numOfCards ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'PERSONS') {
			data.sort((a, b) => {
				return a.numActivePersons > b.numActivePersons ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'TIME') {
			data.sort((a, b) => {
				return a.numTimeRegs > b.numTimeRegs ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'MIN_SEATS') {
			data.sort((a, b) => {
				return a.minimumSeats > b.minimumSeats ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'MIN_VIRTUAL_SEATS') {
			data.sort((a, b) => {
				return a.minimumVirtualSeats > b.minimumVirtualSeats ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'SEATS') {
			data.sort((a, b) => {
				return a.userSeats > b.userSeats ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'UNUSED_SEATS') {
			data.sort((a, b) => {
				const aseats = a.userSeats;
				const aseatsUsed = a.numActivePersons;
				const acalculatedSeatsUsed = Math.max(aseatsUsed, a.minimumSeats || 0);
				const aunusedSeats = aseats - acalculatedSeatsUsed;

				const bseats = b.userSeats;
				const bseatsUsed = b.numActivePersons;
				const bcalculatedSeatsUsed = Math.max(bseatsUsed, b.minimumSeats || 0);
				const bunusedSeats = bseats - bcalculatedSeatsUsed;

				return aunusedSeats > bunusedSeats ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'VIRTUAL_SEATS') {
			data.sort((a, b) => {
				return a.virtualSeats > b.virtualSeats ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'VIRTUAL_USERS') {
			data.sort((a, b) => {
				return a.numVirtualUsers > b.numVirtualUsers ? direction : direction * -1;
			});
		} else if (this.state.sortColumn === 'UNUSED_VIRTUAL_SEATS') {
			data.sort((a, b) => {
				const aval = a.virtualSeats - a.numVirtualUsers;
				const bval = b.virtualSeats - b.numVirtualUsers;

				return aval > bval ? direction : direction * -1;
			});
		}

		const style = {position: 'sticky', top: 0, background: 'white'};

		return (
			<CompanyList>
				<div className="mission-control-list">
					<MissionControlHeader viewer={this.props.viewer} />
					<h1>Company Stats</h1>
					<button onClick={this.changeShow.bind(this)}>{this.state.includeExpiredTrials ? 'Hide expired trials' : 'Show expired trials'}</button>
					<button onClick={this.changeShowCurrent.bind(this)}>{this.state.includeCurrentTrials ? 'Hide current trials' : 'Show current trials'}</button>
					<div style={{maxHeight: '90vh', overflowY: 'scroll'}}>
						<table>
							<tbody>
								<tr>
									<th style={style} onClick={this.sort.bind(this, 'ID')}>
										Id
									</th>
									<th style={style} onClick={this.sort.bind(this, 'NAME')}>
										Name
									</th>
									<th style={style} onClick={this.sort.bind(this, 'TIER')}>
										Tier
									</th>
									<th style={style} onClick={this.sort.bind(this, 'END_DATE')}>
										Trial end
									</th>
									<th style={style} onClick={this.sort.bind(this, 'MIN_SEATS')}>
										Min Seats
									</th>
									<th style={style} onClick={this.sort.bind(this, 'MIN_VIRTUAL_SEATS')}>
										Min Virtual Seats
									</th>
									<th style={style} onClick={this.sort.bind(this, 'SEATS')}>
										Seats
									</th>
									<th style={style} onClick={this.sort.bind(this, 'PERSONS')}>
										Active Persons
									</th>
									<th style={style} onClick={this.sort.bind(this, 'UNUSED_SEATS')}>
										Unused Seats
									</th>
									<th style={style} onClick={this.sort.bind(this, 'VIRTUAL_SEATS')}>
										Virtual Seats
									</th>
									<th style={style} onClick={this.sort.bind(this, 'VIRTUAL_USERS')}>
										Virtual Users
									</th>
									<th style={style} onClick={this.sort.bind(this, 'UNUSED_VIRTUAL_SEATS')}>
										Unused Virtual Users
									</th>
									<th style={style} onClick={this.sort.bind(this, 'PROJECTS')}>
										Projects
									</th>
									<th style={style} onClick={this.sort.bind(this, 'CARDS')}>
										Cards
									</th>
									<th style={style} onClick={this.sort.bind(this, 'TIME')}>
										Time regs
									</th>
									<th style={style} onClick={this.sort.bind(this, 'BLOCKED')}>
										Blocked
									</th>
									<th style={style} onClick={this.sort.bind(this, 'REMOVE')}>
										Remove
									</th>
									<th style={style}>Update UT</th>
								</tr>
								{data.map(s => {
									let tierChange = null;
									if (this.state.tierChangeFor === s.companyId) {
										tierChange = (
											<div>
												<button onClick={this.changeToFreeForever.bind(this, s.companyId)}>Are you sure?</button>
											</div>
										);
									}
									let tierChangeButton = null;
									if (s.tier === 'TRIAL' && isSuperAdmin) {
										tierChangeButton = <button onClick={this.shouldChangeToFreeForever.bind(this, s.companyId)}>Free Forever</button>;
									}

									let picker = null;
									if (this.state.pickerOpenFor === s.companyId) {
										picker = <DatePicker label="Trial end date" value={moment.utc(s.trialEndDate, 'DD-MM-YYYY HH:mm')} onConfirm={this.changeTrialDate.bind(this, s.companyId, s.id)} />;
									} else if (s.tier === 'TRIAL') {
										picker = <button onClick={this.openPicker.bind(this, s.companyId)}>Change</button>;
									}

									let minChange = null;
									if (this.state.minChangeOpenFor === s.companyId) {
										minChange = (
											<div>
												<input ref={input => (this.input = input)} className="min-change-input" defaultValue={s.minimumSeats || 0} type="number" />
												<button onClick={this.changeMinSeats.bind(this, s.companyId)}>save</button>
											</div>
										);
									} else {
										minChange = <button onClick={this.openMinChange.bind(this, s.companyId)}>Change</button>;
									}

									let minVirtualChange = null;
									if (this.state.minVirtualChangeOpenFor === s.companyId) {
										minVirtualChange = (
											<div>
												<input ref={input => (this.inputVirtual = input)} className="min-change-input" defaultValue={s.minimumVirtualSeats || 0} type="number" />
												<button onClick={this.changeMinVirtualSeats.bind(this, s.companyId)}>save</button>
											</div>
										);
									} else {
										minVirtualChange = <button onClick={this.openMinVirtualChange.bind(this, s.companyId)}>Change</button>;
									}

									const toggleBlockButton = <button onClick={this.toggleBlock.bind(this, s.companyId, s.id)}>{s.accessBlocked ? 'Unblock' : 'Block'}</button>;

									const seats = s.userSeats;
									const seatsUsed = s.numActivePersons;
									const calculatedSeatsUsed = Math.max(seatsUsed, s.minimumSeats || 0);
									const unusedSeats = seats - calculatedSeatsUsed;

									const paying = s.tier !== 'TRIAL' && s.tier !== 'FREE_FOREVER';

									return (
										<tr key={s.companyId}>
											<td>{s.companyId}</td>
											<td>{s.companyName}</td>
											<td>
												{this.getTiersMessage(s.tier)}
												{tierChangeButton}
												{tierChange}
											</td>
											<td>
												{s.trialEndDate} {picker}
											</td>
											<td>
												{s.minimumSeats || 0} {minChange}
											</td>
											<td>
												{s.minimumVirtualSeats || 0} {minVirtualChange}
											</td>
											<td>{seats}</td>
											<td>{seatsUsed}</td>
											<td>{paying ? unusedSeats : '-'}</td>
											<td>{s.virtualSeats}</td>
											<td>{s.numVirtualUsers}</td>
											<td>{['LITE', 'PRO', 'ENTERPRISE'].indexOf(s.tier) > -1 ? s.virtualSeats - s.numVirtualUsers : '-'}</td>
											<td>{s.numOfProjects}</td>
											<td>{s.numOfCards}</td>
											<td>{s.numTimeRegs}</td>
											<td>
												{s.accessBlocked ? 'Yes' : 'No'} {toggleBlockButton}
											</td>
											<td>{['LITE', 'PRO', 'ENTERPRISE'].indexOf(s.tier) > -1 ? <button onClick={this.showRemoveSeatsModal.bind(this, s.companyId)}>Remove seats</button> : null}</td>
											<td>
												<button
													disabled={this.state.updatingResourceNumbers}
													onClick={this.updateResourceNumbers.bind(this, s.companyId)}
													title="Queue all persons in the company for an update of their resource numbers. Don't overuse this as it can put a strain on our servers if over used."
												>
													Update UT
												</button>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				</div>
			</CompanyList>
		);
	}
}

const companyStatsQuery = graphql`
	query companyStats_Query {
		viewer {
			actualPersonId
			component(name: "control_company_stats")
			...companyStats_viewer
		}
	}
`;

export {companyStatsQuery};

export default createFragmentContainer(injectIntl(withRouter(companyStats)), {
	viewer: graphql`
		fragment companyStats_viewer on Viewer {
			id
			...missionControlHeader_viewer
			actualPersonId
			missionControlData {
				id
				companyStats {
					id
					companyId
					companyName
					tier
					trialEndDate
					numOfProjects
					numOfCards
					numActivePersons
					numTimeRegs
					minimumSeats
					minimumVirtualSeats
					accessBlocked
					userSeats
					virtualSeats
					numOfClientUsers
					numVirtualUsers
				}
			}
		}
	`,
});
